import React from "react";
import { FormDisclaimerFragment } from "types/graphql-types";
const DefaultSubscribeForm = React.lazy(
  () => import("components/DefaultSubscribeForm/DefaultSubscribeForm")
);
interface RequestBrochureModalFormProps {
  onSubmitSuccess: () => void;
  brochureCode: string;
  formDisclaimerContent: FormDisclaimerFragment | undefined;
}

const OrderBrochureModalForm: React.FC<
  React.PropsWithChildren<RequestBrochureModalFormProps>
> = ({ onSubmitSuccess, brochureCode, formDisclaimerContent }) => {
  return (
    <React.Suspense>
      <DefaultSubscribeForm
        formName="RequestBrochureForm"
        onSubmitSuccess={onSubmitSuccess}
        requestSource="BRO"
        requestType="RAB"
        enableSubscribeEmail={true}
        askImNotTraveAgent={true}
        askWorkWithAgent={true}
        askPhone={true}
        phoneIsRequired
        askAddress={true}
        brochureCode={brochureCode}
        dataContentName="rab_form"
        formDisclaimerContent={formDisclaimerContent}
      />
    </React.Suspense>
  );
};

export default OrderBrochureModalForm;
